import { render, staticRenderFns } from "./historical-arbitrage-order-detail-inquiry.vue?vue&type=template&id=61fb70fa&scoped=true&"
import script from "./historical-arbitrage-order-detail-inquiry.vue?vue&type=script&lang=js&"
export * from "./historical-arbitrage-order-detail-inquiry.vue?vue&type=script&lang=js&"
import style0 from "./historical-arbitrage-order-detail-inquiry.vue?vue&type=style&index=0&id=61fb70fa&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "61fb70fa",
  null
  
)

export default component.exports